import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrescriptionService } from 'src/core/services/prescription.service';
import { Order } from 'src/interfaces/order';
import { FulfilmentItem, OrderItem } from 'src/interfaces/order-item';

interface DialogData {
    order: Order;
    orderItems: OrderItem[];
    title: string;
    message: string;
}

@Component({
    selector: 'core-order-fulfilment-dialog',
    templateUrl: './order-fulfilment-dialog.component.html',
    styleUrls: ['./order-fulfilment-dialog.component.scss']
})
export class OrderFulfilmentDialogComponent implements OnInit {
    scannedItems: FulfilmentItem[] = [];
    unscannedItems: FulfilmentItem[] = [];
    constructor(
        public _dialogRef: MatDialogRef<OrderFulfilmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private _formBuilder: FormBuilder
    ) { }

    ngOnInit(): void {

    }

    onFinishedScanning(item: FulfilmentItem) {
        // on finished scanning 
        const index = this.unscannedItems.indexOf(item);

        if (index > -1) {
            this.unscannedItems.splice(index, 1);
            this.unscannedItems = [...this.unscannedItems];
        }

        // add to scanned items 
        this.scannedItems.push(item);
        this.scannedItems = [...this.scannedItems];
    }

}
